export function LoadingState({ label = 'Loading' }: { label?: string }) {
  return (
    <section className="surface surface--center" aria-live="polite">
      <div className="spinner" aria-hidden="true" />
      <p>{label}</p>
    </section>
  );
}
